export const CORE_BRAND_COLORS = {
    navyBlue: '#00205B',
    red: '#BA0C2F',
    blue: '#4A8CBF',
    grey: '#757A8C',
};

export const BORDER_COLORS = {
    default: '#B4B8BF',
    hover: '#1A5CA2',
    disabled: '#D3DBE5',
    error: '#DA1E28',
    success: '#22A06B',
    focus: '#2171C6',
    actionHover: '#1A5CA2',
    action: '#2171C6',
    white: '#fff',
    warning: '#EB9D06',
    secondary: '#CEE6FF',
    blur: 'rgba(231, 244, 255, 0.40)',
    primary: '#E2E8F0',
    separator: '#F0F3F7',
    accepted: '#0A915C',
    neutral: '#F1F4F8',
    purple: '#661887',
    body: '#50566E',
};

export const TEXT_COLORS = {
    body: '#50566E',
    disabled: '#B4B8BF',
    heading: '#3E445C',
    error: '#DA1E28',
    action: '#2171C6',
    information: '#2171C6',
    filled: '#2F3449',
    poweredBy: '#72ADD6',
    disabledGray: '#70768d',
    success: '#22A06B',
    warning: '#AB7B09',
    onAction: '#FFF',
    purple: '#661887',
};

export const SURFACE_COLORS = {
    page: '#E7F4FF',
    error: '#FFF2F2',
    disabled: '#E2E8F0',
    success: '#F3FFFA',
    information: '#F2F8FD',
    primary: '#F2F8FD',
    warning: '#FFFBED',
    action: '#2171C6',
    actionHover: '#0D3E71',
    white: '#fff',
    default: '#FAFCFE',
    neutral: '#F9FAFB',
    tableCellDark: '#F1F4F8',
    purple: '#FDF9FF',
};

export const ICON_COLORS = {
    primary: '#50566E',
    error: '#DA1E28',
    success: '#22A06B',
    info: '#3699FF',
    warning: '#EB9D06',
    body: '#50566E',
    purple: '#661887',
};

export const DEFAULT_COLORS = {
    white: '#FFFFFF',
    black: '#000000',
};

export const ROOT_TOKENS_COLORS = {
    navyBlue: {
        darker: '#031B33',
        dark: '#042249',
        default: '#00205B',
        light: '#002A73',
        lighter: '#004C98',
    },
    blue: {
        darker: '#164B83',
        dark: '#1A5CA2',
        default: '#2171C6',
        light: '#AFD6FF',
        lighter: '#CEE6FF',
    },
    grey: {
        darker: '#363B4C',
        dark: '#454B62',
        default: '#757A8C',
        light: '#9EA4BA',
        lighter: '#F6F8FE',
    },
    teal: {
        darker: '#0F4549',
        dark: '#20888F',
        default: '#27A3AC',
        light: '#7DC8CD',
        lighter: '#E9F6F7',
    },
    red: {
        darker: '#9E2C2C',
        dark: '#D73D3D',
        default: '#EF4444',
        light: '#FF6D6D',
        lighter: '#FFF2F2',
    },
    green: {
        darker: '#18563E',
        dark: '#1D6E4F',
        default: '#22A06B',
        light: '#46CE9A',
        lighter: '#DFFCF1',
    },
    yellow: {
        darker: '#5F480C',
        dark: '#805F10',
        default: '#B38600',
        light: '#E2B226',
        lighter: '#FFF7D7',
    },
    orange: {
        default: '#D97008',
    },
    white: {
        default: '#FFFFFF',
    },
};
